var e={props:{header:{type:String,default:null},noHighlight:{type:Boolean,default:!1},units:{type:Boolean,default:!1},total:{type:Boolean,default:!1},bold:{type:Boolean,default:!1}}};export default e;
